export default function arrayReduce(array, iterator, initialValue) {
  for (var i = 0, len = array.length; i < len; ++i) {
    initialValue = iterator(initialValue, array[i]);
  }

  return initialValue;
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/fela-utils/es/arrayReduce.js
// module id = 65
// module chunks = 0